// extracted by mini-css-extract-plugin
export default {"page":"NotFound_page__6MZrN","page_image":"NotFound_page_image__LvS+T"};